/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonSerieInfo,
    JsonSerieInfoFromJSON,
    JsonSerieInfoFromJSONTyped,
    JsonSerieInfoToJSON,
} from './JsonSerieInfo';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonSerieInfo
 */
export interface ApiResultOfListOfJsonSerieInfo {
    /**
     * 
     * @type {Array<JsonSerieInfo>}
     * @memberof ApiResultOfListOfJsonSerieInfo
     */
    data?: Array<JsonSerieInfo>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonSerieInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonSerieInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonSerieInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonSerieInfo
     */
    result?: ApiResultOfListOfJsonSerieInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonSerieInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonSerieInfoFromJSON(json: any): ApiResultOfListOfJsonSerieInfo {
    return ApiResultOfListOfJsonSerieInfoFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonSerieInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonSerieInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonSerieInfoFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonSerieInfoToJSON(value?: ApiResultOfListOfJsonSerieInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonSerieInfoToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

